import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useAlerts(params?: { isRead?: boolean; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['alerts', params],
    queryFn: () => api.alerts.list(params),
  });
}

export function useUnreadAlertsCount() {
  return useQuery({
    queryKey: ['alerts', 'unread-count'],
    queryFn: async () => {
      const res = await api.alerts.list({ isRead: false, limit: 0 });
      return { count: res.unreadCount };
    },
    // Poll every minute as a fallback, though we use SSE for real-time
    refetchInterval: 60000,
  });
}

export function useMarkAlertRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.alerts.markAsRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['alerts'] });
    },
  });
}

export function useMarkAllAlertsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.alerts.markAllAsRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['alerts'] });
    },
  });
}
